var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Deposit Box") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M59 2H5a3 3 0 0 0-3 3v50a3 3 0 0 0 3 3h3v2a2 2 0 1 0 4 0v-2h40v2a2 2 0 1 0 4 0v-2h3a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm-3 50H8V42a2 2 0 0 1 0-4V22a2 2 0 0 1 0-4V8h48z",
    fill: "#8d8ea3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M52 12H12v6a2 2 0 0 1 0 4v16a2 2 0 0 1 0 4v6h40zm-12 6a6 6 0 1 1-6 6 6 6 0 0 1 6-6zm4 26h-8a2 2 0 0 1 0-4h8a2 2 0 0 1 0 4zm0-6h-8a2 2 0 0 1 0-4h8a2 2 0 0 1 0 4z",
    fill: "#253858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank5);
export default __webpack_public_path__ + "static/media/bank5.752562a58326814fd2ec523204e601d6.svg";
export { ForwardRef as ReactComponent };